import { Action } from '@ngrx/store';

export enum AppActionTypes {
  Init = '[App] Init',
  LogOut = '[App] Log Out',
  ResetStore = '[App] Reset Store',
  FetchReferenceData = '[App] Fetch Reference Data',
}

export class AppInit implements Action {
  public readonly type = AppActionTypes.Init;
}

export class AppLogOut implements Action {
  public readonly type = AppActionTypes.LogOut;
  constructor(public readonly payload: { showNotification: boolean }) {}
}

export class AppFetchReferenceData implements Action {
  public readonly type = AppActionTypes.FetchReferenceData;
}

export class AppResetStore implements Action {
  public readonly type = AppActionTypes.ResetStore;
}

export type AppActions = AppInit | AppLogOut | AppFetchReferenceData | AppResetStore;
